module.exports = "/_next/static/images/3D@3x-5b7169ec8c9791d7e0a6c8867245d996.png";